import React from 'react';

import { DonateThanks } from 'features/monetization/pages/donate/views/DonateThanks';

export const DonateContainerThanks = () => {
    return <DonateThanks />;
};
